// Format a property's display address. Combines property_label
// (door / flat / shop number — the "12A" or "Flat 301") with the
// street address into a single human-readable string.
//
// Why this exists: the form already collects property_label as a
// separate field, but every display surface used to render only
// `prop.addr`, so the door number was effectively invisible
// outside the edit form. This helper centralises the format so any
// future change (e.g. swap "·" for "—") happens in one place.
//
// Usage: formatPropAddr(prop)            — full label-prefixed address
//        formatPropAddr(prop, { short }) — label only when present, else street
export function formatPropAddr(prop, opts = {}) {
    if (!prop) return "";
    const label = (prop.property_label || "").toString().trim();
    const street = (prop.addr || "").toString().trim();
    if (label && street) return `${label}, ${street}`;
    return label || street || "";
}

// Same data, but as a JSX-friendly object the caller can render with
// distinct emphasis if desired. Returns { label, street, hasLabel }.
export function splitPropAddr(prop) {
    if (!prop) return { label: "", street: "", hasLabel: false };
    const label = (prop.property_label || "").toString().trim();
    const street = (prop.addr || "").toString().trim();
    return { label, street, hasLabel: !!label };
}
